/**
 * Feature flag keys for LaunchDarkly
 * Use these constants with useFeatureFlag hook from @vizit/feature-flags
 *
 * @example
 * import { useFeatureFlag } from '@vizit/feature-flags';
 * import { FEATURE_FLAGS } from '@vizit/constants';
 *
 * const isRetailerEnabled = useFeatureFlag(FEATURE_FLAGS.RETAILER, false);
 */
export const FEATURE_FLAGS = {
  RETAILER: 'retailer',
  /** Controls redirect from /login to /sso when SSO flow is enabled */
  SSO_LOGIN_FLOW: 'sso-login-flow',
  /** Product details page v2 with improved UI layout */
  PDP_V2: 'pdp-v-2',
  /** V2 metric cells in the Product Page Performance section */
  PDP_V2_METRICS: 'pdp-v-2-metrics',
  /** Temporary clip experiment - disables Spark and Explore functionality */
  TMP_CLIP_EXPERIMENT: 'tmp-clip-experiment',
  /** Enables Spark Images generation and tab for hero images (replaces Spark Ideas tab on hero when on) */
  HERO_SPARK_IMAGES: 'hero-spark-images',
  /** Controls visibility of image classification labels on product assets */
  SHOW_IMAGE_CLASSIFICATION: 'show-image-classification',
  /** Controls visibility of Mobile-Readiness panel in Hero Score tab */
  APRIL_SCORING_CHANGES: 'april-scoring-changes',
} as const;

/**
 * Default feature flag values (used when LaunchDarkly is not available)
 * These match the keys in FEATURE_FLAGS
 */
export const FEATURE_FLAG_DEFAULTS = {
  [FEATURE_FLAGS.RETAILER]: false,
  [FEATURE_FLAGS.SSO_LOGIN_FLOW]: false,
  [FEATURE_FLAGS.PDP_V2]: false,
  [FEATURE_FLAGS.PDP_V2_METRICS]: false,
  [FEATURE_FLAGS.TMP_CLIP_EXPERIMENT]: false,
  [FEATURE_FLAGS.HERO_SPARK_IMAGES]: false,
  [FEATURE_FLAGS.SHOW_IMAGE_CLASSIFICATION]: false,
  [FEATURE_FLAGS.APRIL_SCORING_CHANGES]: false,
} as const;

export type FeatureFlagKey = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];
